package de.oevbs.kunde.kundenportal2

import de.oevbs.sfa.info.SfaServiceInfo

object ServiceInfo : SfaServiceInfo {
    override val name: String = "kundenportal2"
    override val version: String = "5.1.0"
    override val buildTime: String = "2025-05-09T10:53:52.944604559+01:00"
}